import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // undefined-like via null while checking
  const [checking, setChecking] = useState(true);

  const bootstrap = useCallback(async () => {
    setChecking(true);
    try {
      const { data } = await api.get("/auth/me");
      setUser(data.user);
    } catch (_) {
      setUser(null);
    } finally {
      setChecking(false);
    }
  }, []);

  useEffect(() => {
    bootstrap();
  }, [bootstrap]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data.user);
    return data;
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    setUser(data.user);
    return data;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (_) {}
    setUser(null);
  };

  const switchRole = async (role) => {
    const { data } = await api.post("/auth/switch-role", { role });
    setUser(data.user);
    return data;
  };

  const addRole = async (role) => {
    const { data } = await api.post("/auth/add-role", { role });
    setUser(data.user);
    return data;
  };

  const refresh = bootstrap;

  return (
    <AuthContext.Provider value={{ user, checking, login, register, logout, switchRole, addRole, refresh }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within AuthProvider");
  return ctx;
}
